import { render, staticRenderFns } from "./packagePlanReview.vue?vue&type=template&id=25b72a5a&"
import script from "./packagePlanReview.vue?vue&type=script&lang=js&"
export * from "./packagePlanReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports